import { FC } from "react";

import Tab from "@joinTrilo/ui/atoms/Tab";
import directionArrowSrc from "../..//assets/DirectionArrow.svg";
import processingSrc from "../../assets/processing.svg";

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import {
    StyledCamelLog,
    StyledDirectionArrow, StyledLogAmount,
    StyledLogBrief,
    StyledLogLeft,
    StyledLogLogo, StyledLogLogoLoader, StyledLogName,
    StyledLogNote,
    StyledLogRight,
    StyledLogRow, StyledLogVis
} from "./YourPayments.styled";

type Props = {
    icon: string;
    name: string;
    description: string;
    amount: string;
    isPaymentProcessing?: boolean;
    isLoading?: boolean;
    logTitle: string;
    status?: string;
};

const YourPayments: FC<Props> = ({
    logTitle,
    icon,
    name,
    description,
    amount,
    isPaymentProcessing = false,
    isLoading = false,
    status = "PENDING",
}: Props) => (
    <StyledCamelLog>
        <Tab
            tabs={[
                {
                    key: logTitle,
                    text: logTitle,
                },
            ]}
        />
        <StyledLogRow>
            <StyledLogLeft>
                <StyledLogVis>
                    {icon && <StyledLogLogo src={icon} alt={name} />}
                    {!icon && <StyledLogLogoLoader />}
                    {!isLoading && <StyledDirectionArrow
                        src={
                            status === "PAID"
                                ? directionArrowSrc
                                : isPaymentProcessing
                                    ? processingSrc
                                    : directionArrowSrc
                        }
                        alt={status === "PAID" ? "SENT" : isPaymentProcessing ? "PROCESSING" : "SENT"}
                    />}
                </StyledLogVis>
                <StyledLogBrief>
                    <StyledLogName>
                        {!isLoading && name}
                        {isLoading && <Skeleton width="150px" height="15px" />}
                    </StyledLogName>
                    <StyledLogNote>
                        {!isLoading && description}
                        {isLoading && <Skeleton width="150px" height="15px" />}
                    </StyledLogNote>
                </StyledLogBrief>
            </StyledLogLeft>
            <StyledLogRight>
                <StyledLogAmount>
                    {!isLoading && amount}
                    {isLoading && <Skeleton width="80px" height="15px" />}
                </StyledLogAmount>
            </StyledLogRight>
        </StyledLogRow>
    </StyledCamelLog>
);

export default YourPayments;
